import { render, staticRenderFns } from "./RoleChart.vue?vue&type=template&id=253c16f5"
import script from "./RoleChart.vue?vue&type=script&lang=js"
export * from "./RoleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports